<template>
  <div class="layout-padding">
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getData"
      title="QA 시트"
      desc="QA 시트 목록"
      ref="qa_sheet">
      <template v-slot:user>
        <button class="button" :class="{'is-primary': mine, 'is-grey': !mine}" style="width:180px"
          @click="setFilter">내 계정 관련 항목만 보기</button>
      </template>
    </admin-filter>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="1200"
                 @getData="getData"
                 @ordering="ordering"
                 @selPageLength="selPageLength">
      <div slot="ftype" slot-scope="props">{{ ftype(props.item.location) }}</div>
      <div style="text-align: left" slot="location" slot-scope="props">{{ locationText(props.item.location) }}</div>
      <div slot="result" slot-scope="props" >{{ props.item.location.result }}</div>
      <div slot="req_content" slot-scope="props" @click="clickItem(props.item)"
           style="cursor:pointer;text-decoration: underline">{{ props.item.req_content }}</div>
      <div slot="task_end_date" slot-scope="props">
        <template v-if="props.item.task_end_date">
          <div class="size-11">{{ datesFormat(props.item.task_end_date, 'date_time_2') }}</div>
          <button v-if="props.item.task_user === $store.getters.admin.id"
                  @click="clickQaCheck(props.item, 'task_end_date', true)">완료 취소
          </button>
        </template>
        <template v-else>
          <button v-if="props.item.task_user === $store.getters.admin.id"
                  @click="clickQaCheck(props.item, 'task_end_date', false)">완료
          </button>
          <div v-else>완료 전</div>
        </template>
      </div>
      <div slot="req_check_date" slot-scope="props">
        <template v-if="props.item.req_check_date">
          <div class="size-11">{{ datesFormat(props.item.req_check_date, 'date_time_2') }}</div>
          <button v-if="props.item.req_user === $store.getters.admin.id"
                  @click="clickQaCheck(props.item, 'req_check_date', true)">확인 취소
          </button>
        </template>
        <template v-else>
          <button v-if="props.item.req_user === $store.getters.admin.id"
                  @click="clickQaCheck(props.item, 'req_check_date', false)">확인
          </button>
          <div v-else>확인 전</div>
        </template>
      </div>
    </admin-table>
    <modal name="detailModal" height="auto" :width="800" v-if="selectedItem">
      <qa-sheet-detail-modal :qa="selectedItem" @close="closeDetail"></qa-sheet-detail-modal>
    </modal>
  </div>
</template>

<script>
  import ListMixin from "../../../../mixins/ListMixin";
  import QaSheetDetailModal from "../../../module/common/qa/QaSheetDetailModal";

  export default {
    name: "QaSheet",
    components: {QaSheetDetailModal},
    mixins: [
      ListMixin
    ],
    created() {
      this.init();
    },
    data() {
      return {
        mine: false,
        selectedItem: undefined
      }
    },
    methods: {
      init() {
        this.initializing('qa_sheet', 'launchpack/qa_sheet');
      },
      setFilter() {
        if(this.mine) {
          delete this.filtered.mine;
          this.mine = false;
        } else {
          this.filtered.mine = this.$store.getters.admin.id;
          this.mine = true;
        }
        this.getData();
      },
      ftype(item) {
        return {
          front_action: '프론트',
          admin_feature: '백오피스',
          builder_feature: '빌더'
        }[item.type];
      },
      locationText(item) {
        let result = '';
        if (item.type === 'front_action') {
          result = `${item.location_name} > ${item.feature_name} > ${item.name}`;
        } else {
          result = `${item.location_name} > ${item.content}`;
        }

        return result;
      },
      clickQaCheck(item, key, isCancel) {
        let date = '';
        if (!isCancel) {
          date = this.moment().format('YYYY-MM-DD HH:mm:ss');
        }
        let params = {};
        params[key] = date;
        this.$axios.patch(`admin/launchpack/qa_sheet/${item.id}`, params).then(res => {
          if (res.status === 200) {
            item[key] = date;
          }
        });
      },
      clickItem(item) {
        this.selectedItem = item;
        setTimeout(()=>{
          this.$modal.show('detailModal');
        },300);
      },
      closeDetail() {
        this.$modal.hide('detailModal');
        setTimeout(()=>{
          this.selectedItem = undefined;
        },300);
      }
    }
  }
</script>

<style lang="stylus" scoped>

</style>
